import React, { useRef, useEffect } from 'react';

var intervalId;
var SnowFlakes = function (_a) {
    var _b = _a.snowCount, snowCount = _b === void 0 ? 50 : _b;
    var canvasTag = useRef(null);
    useEffect(function () {
        var canvas = canvasTag.current;
        var ctx = canvas.getContext('2d');
        var W = window.innerWidth;
        var H = window.innerHeight;
        canvas.width = W;
        canvas.height = H;
        var particles = [];
        // eslint-disable-next-line no-plusplus
        for (var i = 0; i < snowCount; i++) {
            particles.push({
                x: Math.random() * W,
                y: Math.random() * H,
                r: Math.random() + 2,
                d: Math.random() * snowCount,
            });
        }
        var draw = function () {
            ctx.clearRect(0, 0, W, H);
            ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';
            ctx.beginPath();
            // eslint-disable-next-line no-plusplus
            for (var i = 0; i < snowCount; i++) {
                var p = particles[i];
                ctx.moveTo(p.x, p.y);
                ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2, true);
            }
            ctx.fill();
            update();
        };
        var angle = 0;
        var update = function () {
            angle += 0.01;
            // eslint-disable-next-line no-plusplus
            for (var i = 0; i < snowCount; i++) {
                var p = particles[i];
                p.y += Math.cos(angle + p.d) + 1 + p.r / 2;
                p.x += Math.sin(angle) * 2;
                if (p.x > W + 5 || p.x < -5 || p.y > H) {
                    if (i % 3 > 0) {
                        particles[i] = {
                            x: Math.random() * W,
                            y: -10,
                            r: p.r,
                            d: p.d,
                        };
                    }
                    else if (Math.sin(angle) > 0) {
                        particles[i] = {
                            x: -5,
                            y: Math.random() * H,
                            r: p.r,
                            d: p.d,
                        };
                    }
                    else {
                        particles[i] = {
                            x: W + 5,
                            y: Math.random() * H,
                            r: p.r,
                            d: p.d,
                        };
                    }
                }
            }
        };
        intervalId = setInterval(draw, 40);
        return function () {
            clearInterval(intervalId);
        };
    }, []);
    return React.createElement("canvas", { ref: canvasTag, id: 'canvas' });
};

export { SnowFlakes as default };
